<template>
    <h1 id="item-name-header" v-text="`${item.name}`"></h1>
    <hr>
    <p v-html="`${item.description}`"></p>

    <br>

    <div v-if="this.groups.length > 0">
        <div v-for="(group, key) in groups">
            <p class="mb-2" v-text="`${group.name}`"></p>
            <select v-model="options[key]" @change="CalculatePrice()" class="form-select mb-4" :class="{ 'option-empty': options[key] == '' || options[key] == undefined }" style="width: 50%;">
                <option v-for="option in group.options" :value="`${ option.id }`" v-text="this.OptionWithPriceMod(option)"></option>
            </select>
        </div>
    </div>

    <h2>&pound;<span v-text="`${this.price}`"></span></h2>

    <div class="flex-x center-x">
        <input class="form-control" style="width: 60px;" type="number" v-model="this.quantity" name="quantity" />
        <button type="button" class="btn btn-warning my-2 mx-2" @click="this.AddToCart()">
            <i class="fas fa-cart-plus"></i> Add To Cart
        </button>
    </div>

</template>

<script>
export default {

    data () {
        return {
            options: [],
            quantity: 1,
            price: 0
        }
    },

    props: ['item', 'groups'],

    created () {
        this.price = parseFloat(this.item.price);

        this.groups.forEach( group => {
            group.options.unshift({
                id: undefined,
                name: "Select option"
            });
        });

        console.log(this.groups);
    },

    methods: {

        OptionWithPriceMod (option) {
            var name = option.name;
            if ( option.price_modifier != 0 && option.price_modifier != undefined ) name += ` (+£${option.price_modifier})`;
            return name;
        },

        CalculatePrice () {
            this.price = parseFloat(this.item.price);

            var allOptions = [];
            this.groups.forEach((group) => {
                group.options.forEach((opt) => {
                    allOptions.push(opt);
                });
            });

            this.options.forEach((option) => {
                if ( option == "" || option == undefined ) return;
                var data = allOptions.find( o => o.id == option );
                this.price += parseFloat(data.price_modifier);
            });
        },

        async AddToCart () {

            if ( this.options.length < this.groups.length ) {
                window.ErrorToast("Please select all options");
                return;
            }

            this.options.forEach((option) => {
                if ( option == "" || option == undefined ) { 
                    return; 
                }
            });

            try {
                const response = await axios.post('/cart/add', {
                    id: this.item.id,
                    quantity: this.quantity,
                    options: this.options
                });
                window.Toast(this.item.name + " added to cart");
            } catch ( err ) {
                window.ErrorToast("Couldn't add item to cart. Make sure you are logged into your Discord account.");
            }

        },

    }

}
</script>